<script setup lang="ts">
import { defineAsyncComponent, onMounted, ref } from 'vue';
import { IonContent, IonPage } from '@ionic/vue';
import LandingHeader from '@/components/landing/LandingHeader.vue';
import LandingHero from '@/components/landing/LandingHero.vue';

const LandingFeatures = defineAsyncComponent(() => import('@/components/landing/LandingFeatures.vue'));
const LandingHowItWorks = defineAsyncComponent(() => import('@/components/landing/LandingHowItWorks.vue'));
const LandingDownload = defineAsyncComponent(() => import('@/components/landing/LandingDownload.vue'));
const LandingFooter = defineAsyncComponent(() => import('@/components/landing/LandingFooter.vue'));

const showBelowFold = ref(false);

// "Scarica per Android" → redirect diretto alla scheda Play Store dell'app.
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.swapwish.app';

function goToPlayStore() {
  window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
}

function scrollToSection(sectionId: string) {
  document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

onMounted(() => {
  const reveal = () => { showBelowFold.value = true; };
  const ric = (window as Window & {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
  }).requestIdleCallback;
  if (ric) ric(reveal, { timeout: 250 });
  else requestAnimationFrame(() => requestAnimationFrame(reveal));
});
</script>

<template>
  <ion-page class="lp-page">
    <ion-content :fullscreen="true" class="lp-page-content">
      <LandingHeader @scroll-to="scrollToSection" />
      <main>
        <LandingHero />
        <template v-if="showBelowFold">
          <LandingFeatures />
          <LandingHowItWorks />
          <LandingDownload @download="goToPlayStore" />
        </template>
      </main>
      <LandingFooter v-if="showBelowFold" />
    </ion-content>
  </ion-page>
</template>

<style>
/* Non-scoped: landing-page section rhythm, scoped to .lp-page descendants */
.lp-page section {
  padding-block: 100px;
  scroll-margin-top: 72px;
}
@media (max-width: 768px) {
  .lp-page section {
    padding-block: 64px;
    scroll-margin-top: 72px;
  }
}
</style>

<style scoped>
.lp-page {
  min-height: 100vh;
  color: var(--text-main);
  font-family: var(--ion-font-family);
  -webkit-font-smoothing: antialiased;
}
.lp-page-content {
  --background: transparent;
}
.lp-page main {
  padding-top: 72px;
}
</style>
